import {isFilled} from '@prismicio/client'
import {PrismicRichText} from '@prismicio/react'
import NextLink from 'next/link'
import {useLinkResolver} from 'prismicio'
import type {TextBlockSliceDefault} from 'prismicio-types'
import {memo} from 'react'
import {ActionButton} from 'src/common/ActionButton'
import {ButtonV2} from 'src/common/ButtonV2'
import type {Context} from 'src/common/types'

export const TextBlockDefault = (props: {slice: TextBlockSliceDefault; context: Context}) => {
  const {linkResolver} = useLinkResolver()
  return (
    <section
      className="grid scroll-mt-16 grid-cols-main gap-y-6 pb-8 pt-4 text-232f2a sm:pb-12 sm:pt-6 md:pb-16 md:pt-10 lg:pb-16 lg:pt-20"
      id={String(props.slice.primary.id_anchor)}
    >
      <h2 className="col-[inner] text-28 font-bold -tracking-common md:col-end-[track-end_6]">
        {props.slice.primary.title}
      </h2>

      <div className="col-[inner] grid gap-y-6 md:col-start-[track-start_7]">
        <div>
          <PrismicRichText
            components={{
              paragraph: ({children}) => <p className="text-16 leading-6">{children}</p>,
              label: ({children, node}) => {
                if (node.data.label === 'intercom' && typeof window !== 'undefined' && window.Intercom) {
                  return (
                    <ButtonV2
                      variant="primary"
                      className="!h-10 justify-self-start !text-[11px] !tracking-[.72px]"
                      onClick={() => window.Intercom?.('show')}
                      trackingData={{
                        mktgId: 'intercom-chat-text-block',
                        location: 'component-text-block',
                        dataType: 'intercom-button',
                        pageName: props.context.pageUid,
                      }}
                    >
                      {children}
                    </ButtonV2>
                  )
                }

                return <></>
              },
              hyperlink: ({children, node}) => (
                <NextLink
                  className="text-22 leading-7"
                  href={linkResolver(node.data)}
                  {...(isFilled.link(node.data) && node.data.link_type === 'Web' && {target: node.data.target})}
                >
                  {children}
                </NextLink>
              ),
              heading3: ({children}) => <p className="text-22 leading-7">{children}</p>,
            }}
            field={props.slice.primary.text}
          />
        </div>

        {isFilled.link(props.slice.primary.link) && !props.slice.primary.is_link_intro && (
          <ButtonV2
            className="!h-10 justify-self-start !text-[11px] !tracking-[.72px]"
            href={linkResolver(props.slice.primary.link, 'primary-button-text-block')}
            {...(isFilled.link(props.slice.primary.link) &&
              props.slice.primary.link.link_type === 'Web' && {
                target: props.slice.primary.link.target,
              })}
            trackingData={{
              mktgId: 'primary-button-text-block',
              location: `component-text-block`,
              dataType: 'primary-button',
              pageName: props.context.pageUid,
              label: props.slice.primary.link_label!,
            }}
            variant="primary"
          >
            {props.slice.primary.link_label}
          </ButtonV2>
        )}

        {props.slice.primary.is_link_intro && (
          <ActionButton className="justify-self-start text-[11px] !font-[600] uppercase" kind="demo">
            {props.slice.primary.link_label}
          </ActionButton>
        )}
      </div>
    </section>
  )
}

export default memo(TextBlockDefault)
